import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.tsx";
import "./styles.css";
import "./components/settings.css";
import "./user-settings.css";
import { installViewportSizing } from "./mobile.ts";
import { installPush } from "./push.ts";
import { installTheme } from "./theme.ts";
import { installDensity } from "./density.ts";
import { installChatLayout } from "./layout.ts";
import { installTextSize } from "./textSize.ts";
import { installColoredNames } from "./coloredNames.ts";
import { installAnalytics } from "./analytics.ts";
import { installRum } from "./rum.ts";
import { preloadEmoji } from "./emoji.ts";

const ddApplicationId = import.meta.env.VITE_DD_APPLICATION_ID || "60a17777-db4f-4bd1-a108-9bc910754201";
const ddClientToken = import.meta.env.VITE_DD_CLIENT_TOKEN || "pub3e553de6ff5bd906092f258de97de162";
const ddEnv = import.meta.env.VITE_DD_ENV || (location.hostname === "bloom.somalabs.dev" ? "prod" : "dev");
const ddExplicitKey = Boolean(import.meta.env.VITE_DD_CLIENT_TOKEN || import.meta.env.VITE_DD_APPLICATION_ID);

installTheme();
installDensity();
installChatLayout();
installTextSize();
installColoredNames();
installViewportSizing();
installPush();
// Usage events (PostHog) and RUM (Datadog), loaded after the page is up and the browser is idle; off on local and test servers unless a key is explicitly configured.
installAnalytics();
installRum({ applicationId: ddApplicationId, clientToken: ddClientToken, env: ddEnv, explicitKey: ddExplicitKey });
// Emoji data, the same way: ready before the first reaction or ":".
preloadEmoji();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  addEventListener("load", () => navigator.serviceWorker.register("/sw.js").catch(() => {}));
}
